import React from "react";
import * as io from "io-ts";
import { nullable } from "diagnostics-lib/io";
import createGlobalState from "@ui/lib/createGlobalState";
import type { Reporting } from "../../../api/useReporting";

const useQOIName = createGlobalState({
  storage: "session",
  key: "reporting-qoi-name",
  type: nullable(io.string),
  scoped: false,
});

export const useQOI = (reporting: Reporting) => {
  const [QOIName, setQOIName] = useQOIName({});
  const qoi = React.useMemo(
    () =>
      Object.values(reporting.qoiById).find(q => q.name === QOIName) ??
      Object.values(reporting.qoiById)[0] ??
      null,
    [reporting.qoiById, QOIName],
  );

  if (!qoi) throw new Error("no QOI not found in reporting");

  return [qoi, setQOIName] as const;
};
